<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="loading" />
        <div v-if="!loading">
          <crud-list
            v-model="categorias"
            :headers="headers"
            :actions="actions"
            :permission="'list_categoria'"
            :sort-by="['codigo']"
            :slots="[
              'item.id',
              'item.status',
              'item.codigo',
              'item.descricao',
              'item.tipo',
              'item.tipo_pessoa',
            ]"
            :sort-desc="[false]"
          >
            <template
              v-slot:btnCadastro
            >
              <v-col>
                <v-row>
                  <v-col>
                    <v-menu
                      open-on-hover
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="text-none text-white"
                          color="primary"
                          v-bind="attrs"
                          rounded
                          block
                          v-on="on"
                        >
                          <v-icon
                            dark
                            left
                          >
                            mdi-file-move
                          </v-icon>
                          Exportar
                        </v-btn>
                      </template>
                      <v-list class="ma-0 pa-0">
                        <v-list-item
                          :key="1"
                          :class="{active: true}"
                          @click="exportarExcel"
                        >
                          <v-list-item-title
                            class="mx-2 px-0"
                          >
                            <v-icon
                              color="green"
                              class="mx-2 px-0"
                            >
                              mdi-file-excel
                            </v-icon>
                            Exportar XLSX
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          :key="2"
                          :class="{active: true}"
                          @click="exportarPdf"
                        >
                          <v-list-item-title class="mx-2 px-0">
                            <v-icon
                              color="red"
                              class="mx-2 px-0"
                            >
                              mdi-file-pdf
                            </v-icon>
                            Exportar PDF
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="hasPermission('inserir_categoria')">
                <v-btn
                  class="text-none text-white"
                  block
                  rounded
                  color="primary"
                  title="Cadastrar nova categoria"
                  @click="$router.push({ path: 'fluxoCaixaCategorias/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
            <template
              v-if="hasPermission('ativar_categoria')"
              v-slot:[`item.status`]="{ item }"
            >
              <v-checkbox
                v-if="item.classe === 'A'"
                v-model="item.status"
                class="mt-0"
                color="success"
                :readonly="!hasPermission('ativar_categoria')"
                :loading="false"
                hint="Ativar/Desativar categoria!"
                hide-details
                @change="TOGGLE_CATEGORIA_STATUS(item)"
              />
            </template>
            <template v-slot:[`item.codigo`]="{ item }">
              <span
                v-if="item.classe === 'T'"
                style="font-weight: bold;"
              >
                {{ item.codigo }}
              </span>
              <span
                v-if="item.classe === 'S'"
                style="font-weight: bold;"
              >
                {{ item.codigo }}
              </span>
              <span v-if="item.classe === 'A'">
                {{ item.codigo }}
              </span>
            </template>
            <template v-slot:[`item.descricao`]="{ item }">
              <span
                v-if="item.classe === 'T'"
                style="font-weight: bold;"
              >
                {{ item.descricao }}
              </span>
              <span
                v-if="item.classe === 'S'"
                style="font-weight: bold; padding-left: 20px;"
              >
                {{ item.descricao }}
              </span>
              <span
                v-if="item.classe === 'A'"
                style="padding-left: 40px;"
              >
                {{ item.descricao }}
              </span>
            </template>
            <template v-slot:[`item.tipo`]="{ item }">
              <span>{{ item.classe === 'A' ? item.tipo === 0 ? 'Receita' : item.tipo === 1 ? 'Despesa' : '' : '' }}</span>
            </template>
            <template v-slot:[`item.tipo_pessoa`]="{ item }">
              <span>{{ item.classe === 'A' ? item.tipo_pessoa === 0 ? 'Associado' : item.tipo_pessoa === 1 ? 'Fornecedor' : item.tipo_pessoa === 2 ? 'Funcionário' : item.tipo_pessoa === 3 ? 'Avulso' : '' : '' }}</span>
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import store from '@/store'
  import CategoriasStore, { BOOTSTRAP, INATIVAR_CATEGORIA, TOGGLE_CATEGORIA_STATUS } from '@/store/modules/categorias'
  import { mapState, mapActions, mapGetters } from 'vuex'
  import jsPDF from 'jspdf'
  import XLSX from 'xlsx'
  export default {
    data () {
      return {
        actions: [
          {
            title: 'Editar categoria',
            color: 'info darken-3',
            click: item => this.getCategoria(item),
            icon: 'mdi-pencil',
            permission: 'editar_categoria',
          },
          {
            title: 'Excluir categoria',
            color: 'red darken-3',
            click: item => this.INATIVAR_CATEGORIA(item),
            icon: 'mdi-trash-can-outline',
            permission: 'excluir_categoria',
          },
        ].filter(action => store.getters.hasPermission(action.permission)),
        headers: [
          { text: '', value: 'actions', sortable: false, groupable: false, floatingfilter: false, width: '40px' },
          { align: 'left', sortable: true, groupable: false, floatingfilter: true, text: 'Status', value: 'status', width: 'auto', report: true },
          { align: 'left', sortable: true, groupable: false, floatingfilter: true, text: 'Código', value: 'codigo', width: 'auto', report: true },
          { align: 'left', sortable: true, groupable: false, floatingfilter: true, text: 'Descrição', value: 'descricao', width: 'auto', report: true },
          { align: 'left', sortable: false, groupable: false, floatingfilter: false, text: 'Tipo', value: 'tipo', width: 'auto', report: true },
          { align: 'left', sortable: false, groupable: false, floatingfilter: false, text: 'Tipo de Pessoa', value: 'tipo_pessoa', width: 'auto', report: true },
        ],
      }
    },
    computed: {
      ...mapState('categorias', ['loading', 'categorias']),
      ...mapGetters(['hasPermission']),
    },
    async created () {
      if (!this.$store.hasModule('categorias')) { this.$store.registerModule('categorias', CategoriasStore) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('categorias', [BOOTSTRAP, INATIVAR_CATEGORIA, TOGGLE_CATEGORIA_STATUS]),
      getCategoria ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/fluxoCaixaCategorias/alterar`,
          query: { id },
        })
      },
      exportarExcel () {
        const data = this.categorias
        try {
          var table = [
            ['Relatorio Eventos de Cálculo'],
            [''],
            ['Status', 'Código', 'Descrição', 'Tipo', 'Tipo de Pessoa'],
          ]
          data.forEach(item => {
            table.push([
              item.status === 0 ? 'Inativo' : 'Ativo',
              item.codigo,
              item.descricao,
              item.tipo === 0 ? 'Receita' : 'Despesa',
              item.tipo_pessoa === 0 ? 'Associado' : (item.tipo_pessoa === 1 ? 'Fornecedor' : item.tipo_pessoa === 2 ? 'Funcionário' : 'Avulso'),
            ])
          })
          var ws = XLSX.utils.aoa_to_sheet(table)

          const colWidths = table[3].map((_, colIndex) => table.reduce((maxWidth, currentRow) => {
            const cellValue = currentRow[colIndex]
            const cellWidth = (typeof cellValue === 'string' ? cellValue.length : 0)
            return Math.max(maxWidth, cellWidth)
          }, 0))

          ws['!cols'] = colWidths.map(width => ({ wch: width + 2 }))

          var wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, 'Relatorio Categoria')

          XLSX.writeFile(wb, 'Relatorio Categoria.xlsx')
        } catch (e) {
          console.log(e)
        }
      },
      exportarPdf () {
        const spaceLine = 7
        const fontSize = spaceLine + 1
        const fontTitleSize = fontSize * 2
        const margin = { left: 10, right: 10, bottom: 10, top: 28 }

        function addHeader () {
          doc.addImage(window.location.origin + '/img/logo_branca.png', 'png', margin.left, 5, fontSize * 1.8, fontSize * 1.8)
          doc.setFontSize(fontTitleSize)
          doc.text('Relatorio Categoria', docWidth / 2, 15, { align: 'center' })
          doc.setFontSize(fontSize)
          doc.text(dateNow, docWidth - margin.right, (20), { align: 'right' })
          doc.line(5, (24), docWidth - 5, (24))
        }

        function addFooter (pageNumber) {
          doc.setFontSize(fontSize - 1)
          doc.text(dateNow, margin.left - 5, docHeight - margin.bottom)
          doc.text('Página ' + pageNumber + ' / ' + totalPages, docWidth + 17, docHeight - margin.bottom, { align: 'right' })
        }

        var doc = new jsPDF({
          orientation: 'landscape',
        })
        var totalPages = '{total_pages_count_string}'
        const dateNow = (new Date()).toLocaleString()
        const docWidth = doc.internal.pageSize.width
        const docHeight = doc.internal.pageSize.height
        var cols = [
          { title: 'Status', dataKey: 'status' },
          { title: 'Código', dataKey: 'codigo' },
          { title: 'Descrição', dataKey: 'descricao' },
          { title: 'Tipo', dataKey: 'tipo' },
          { title: 'Tipo de Pessoa', dataKey: 'tipo_pessoa' },
        ]
        doc.autoTable({
          theme: 'plain',
          headStyles: {
            textColor: '#FFFFFF',
            fillColor: '#1E88E5',
          },
          columns: cols,
          columnStyles: {
            codigo: { halign: 'center' },
            valor_evento: { halign: 'right' },
          },
          body: this.categorias,
          startY: 27,
          pageBreak: 'auto',
          margin: { left: 5, top: margin.top, bottom: (margin.bottom + 5), right: 5 },
          didParseCell: function (data) {
            if (data.section === 'body') {
              if (data.column.dataKey === 'status') {
                if (parseInt(data.cell.text) === 1) {
                  data.cell.text = 'Ativo'
                }
                if (parseInt(data.cell.text) === 0) {
                  data.cell.text = 'Inativo'
                }
              }
              if (data.column.dataKey === 'tipo') {
                if (parseInt(data.cell.text) === 0) {
                  data.cell.text = 'Receita'
                }
                if (parseInt(data.cell.text) === 1) {
                  data.cell.text = 'Despesa'
                }
              }
              if (data.column.dataKey === 'tipo_pessoa') {
                if (parseInt(data.cell.text) === 0) {
                  data.cell.text = 'Associado'
                }
                if (parseInt(data.cell.text) === 1) {
                  data.cell.text = 'Fornecedor'
                }
                if (parseInt(data.cell.text) === 2) {
                  data.cell.text = 'Funcionário'
                }
                if (parseInt(data.cell.text) === 3) {
                  data.cell.text = 'Avulso'
                }
              }
            }
          },
          didDrawPage: (data) => {
            addHeader()
            addFooter(data.pageNumber)
          },
        })
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPages)
        }

        doc.save('Relatorio Categoria' + '.pdf')
      },
    },
  }
</script>
